import { Box, Typography } from '@mui/material';
import ITUIcon from '../../components/Icons/ITU';

function Logo() {
  return (
    <Box className='login-title-block'>
      <ITUIcon width={100} height={100} />
      <Typography color='#079dd5' fontWeight='bold' variant='h5' display='inline'>
        ITU World Telecommunication/ICT and Digital Regulatory Survey
      </Typography>
      <Typography color='#079dd5' fontWeight='bold' variant='h5' display='inline'>
        ITU Tariff Policies Survey
      </Typography>
    </Box>
  );
}

export default Logo;
